import nf from "@tuplo/numberfmt";

export const formatData = (value: number | string | Date, format?: any) => {
  // if (typeof value === "number" && value <= 0) {
  //   return "⦁";
  // } else return nf(value, format, { locale: "en-US" });
  if (typeof value === "number") {
    if (format) {
      return nf(value, format, { locale: "en-US" });
    }
    return new Intl.NumberFormat("en", { notation: "compact" }).format(value);
  }
  return value as string;

  // return nf(value, format, { locale: "en-US" });
};
